export enum ApplicationSubType {
  ParentInstallation = 21,
  PreInstallation = 22,
  Installation = 23,
  Instruction = 24
}
